import React from "react";
import { StyleSheet, Pressable } from "react-native";
import Text from "@components/ds/DsText";
import GridIcon from "./GridIcon";
import { tokens } from "@components/ds/tokens";

// Free-rack chip (spec p2 frame 3, "FREE RACKS NEARBY") — small white
// rounded chip with a grid glyph + rack no, wrapping in a row (the parent
// renders these in a flexWrap View, not a FlatList — there are only ever
// a handful of free racks at once). Selected = filled green, matching the
// mock's "make the selected rack visibly chosen" note.

const FreeRackRow = ({ rack, selected, onPress }) => (
  <Pressable
    testID={`receiving-free-rack-${rack.rack_no}`}
    onPress={() => onPress(rack)}
    style={[styles.chip, selected && styles.chipSelected]}
  >
    <GridIcon
      size={5}
      color={selected ? tokens.surface : tokens.textSecondary}
    />
    <Text
      variant="body_text_4"
      style={[styles.rackNo, selected && styles.textSelected]}
    >
      {rack.rack_no}
    </Text>
    {rack.rack_name ? (
      <Text
        variant="caption_2"
        style={[styles.rackName, selected && styles.textSelected]}
      >
        · {rack.rack_name}
      </Text>
    ) : null}
  </Pressable>
);

export default FreeRackRow;

const styles = StyleSheet.create({
  chip: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 8,
    paddingHorizontal: tokens.spacing.medium,
    borderRadius: tokens.radius.full,
    borderWidth: 1,
    borderColor: tokens.borderMedium,
    backgroundColor: tokens.surface,
    marginRight: tokens.spacing.small,
    marginBottom: tokens.spacing.small,
  },
  chipSelected: {
    backgroundColor: tokens.primary,
    borderColor: tokens.primary,
  },
  // No fontWeight — variant="body_text_4" already carries semiBold weight.
  rackNo: { color: tokens.textPrimary, marginLeft: 6 },
  rackName: { color: tokens.textSecondary, marginLeft: 4 },
  textSelected: { color: tokens.surface },
});
